const initialState = {
    fullname: '',
    mobile: '',
    comment: '',
    subject: ''
};
const contactUs = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INPUTS_PAGE_CONTACT_US':
            return {...state, [action.name]:  action.value};
        default:
            return state;
    }
};

export default contactUs;